var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutoOrdered = function SvgAutoOrdered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.98 6.197a4.25 4.25 0 0 1-7.907 1.679l-.125-.217m-.421-2.355a4.25 4.25 0 0 1 7.907-1.679l.125.217M1.5 8.784l.366-1.366 1.366.366m5.043-4.066 1.366.366.366-1.366"
  })));
};
export default SvgAutoOrdered;